import Vue from "vue";

export default function customizeElementUI() {
  // テーブルのデータ更新後にレイアウトが崩れるのを防止する
  const originalTable = Vue.component('ElTable');
  const customTable = originalTable.extend({
    mounted() {
      this.$watch(
        'data',
        function(this: Vue) {
          this.$nextTick(() => {
            // @ts-ignore
            this.resizeListener();
          });
        }
      );
    }
  });
  Vue.component('ElTable', customTable);
}
